<template>
  <div class="app-header">
    <div class="app-header__wrap">
      <div class="header-left" @click="goHome">
        <el-image v-if="logo" :src="logo" fit="contain" class="logo mr-20">
          <div slot="error">
            <i class="el-icon-picture-outline"></i> 企业Logo
          </div>
        </el-image>
        <span class="header-left_goBack" v-if="isShowGoback" @click.stop="navBack">&lt; {{$t('home.goBack')}}</span>
      </div>
      <div class="header-center">
        <h1 class="header-center_title" style="font-size: 20px;">{{title}}</h1>
      </div>
      <div class="header-right">
        <user-set></user-set>
        <lang class="doropdown"></lang>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import UserSet from './UserSet';
import HeadMenu from './HeadMenu';
import Breadcrumb from './Breadcrumb';
import lang from './Lang';

export default {
  components: {
    Breadcrumb,
    UserSet,
    HeadMenu,
    lang,
  },
  computed: {
    ...mapGetters(['getMenuCollapse']),
    ...mapState('corporation', ['corporation']),
    logo() {
      return this.corporation.logo;
    },
    title() {
      if (this.$route.meta && this.$route.meta.attachProject) {
        return this.$store.getters['project/currentProjectTitle'];
      }
      if (this.$route.query.projectId) {
        return this.$store.getters['project/currentProjectTitle'];
      }
      return this.$store.getters['corporation/currentCorpTitle'];
    },
  },
  watch: {
    'corporation.favicon': {
      handler(val) {
        if (!val) return;
        const link = document.querySelector('link[rel*="icon"]')
          || document.createElement('link');
        link.rel = 'shortcut icon';
        link.href = val;
        document.getElementsByTagName('head')[0].appendChild(link);
      },
    },
    $route(to) {
      if (to.name === 'Home' && (to.query.projectId || to.query.structureId)) {
        this.isShowGoback = true;
      } else {
        this.isShowGoback = false;
      }
    },
  },
  data() {
    return {
      isShowGoback: false,
    };
  },
  mounted() {
    if (this.$route.name === 'Home' && (this.$route.query.projectId || this.$route.query.structureId)) {
      this.isShowGoback = true;
    } else {
      this.isShowGoback = false;
    }
  },
  methods: {
    ...mapActions(['setCollapse']),
    handleMenuFold() {
      this.setCollapse(!this.getMenuCollapse);
    },
    navBack() {
      if (this.$route.query.projectId && this.$route.query.structureId) {
        this.$router.replace({ name: 'Home', query: { projectId: this.$route.query.projectId } });
      } else if (this.$route.query.projectId) {
        this.$router.replace({ name: 'Home' });
      }
    },
    goHome() {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/styles/var.scss";
@import "../../../assets/styles/mixin.scss";
@import '../../../assets/theme/_themes.scss';
$headerHeight: 60px;
.app-header {
  box-sizing: border-box;
  width: 100%;
  height: $headerHeight;
  line-height: $headerHeight;
  z-index: 100;
  @include background_color('background-color-nav');
  position: relative;
  flex-direction: row;
  flex-wrap: nowrap;

  &::after {
    position: absolute;
    content: '';
    height: 1px;
    background: linear-gradient(-297deg, rgba(51, 172, 237, 0) 0%, rgba(67, 186, 241, 0.4) 20%, #62CBF7 50%, rgba(68, 186, 241, 0.4) 80%, rgba(51, 172, 237, 0) 100%);
    left: 0;
    bottom: 0;
    width: 100%;

  }

  &__wrap {
    @include flex(row);
    justify-content: space-between;
    align-items: center;
  }
  h1 {
    font-size: 24px;
    font-weight: bold;
    color: #fff;
    margin: 0;
    // line-height: 60px;
  }
  .logo {
    width: auto;
    height: $headerHeight;
  }
  .menu-fold {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }
  .base-icon {
    margin-right: 20px;
  }

  .breadcrumb {
    flex: 1;
  }
  .header-center {
    text-align: center;
    position: absolute;
    left: 50%;
    top: 30px;
    transform:translate(-50%,-50%);
  }
  .header-left, .header-right {
    height: 100%;
    overflow: hidden;
    @include flex(row);
    .doropdown {
      margin-right: 20px;
    }
  }
  .header-right {
    @include background_color('background-color-nav_right');
  }
  .header-left {
    cursor: pointer;
    &_goBack {
      color: #ffffff;
      display: inline-block;
    }
  }
}
.select-theme-popover {
  .row {
    display: flex;
    justify-content: flex-start;
  }
  .item {
    margin: 10px;
    width: 30px;
    height: 30px;
    border: 1px solid #ccc;
  }
}
</style>

<style lang="scss">
.app-header__wrap .logo {
  img {
    width: auto;
    height: 100%;
  }
}
</style>
